export var IDENTIFIER_DROPDOWN = 'dropdown';
export var IDENTIFIER_DROPDOWN_OPTIONS = 'dropdown-options';
